type ModelCarrier = {
  model?: string | null;
  instrumentModel?: string | null;
};

/** True when the model is a Vitari instrument. Same trim and case rule `telemetryLogsRoot` uses. */
export function isVitariModel(model?: string | null): boolean {
  return model?.trim().toUpperCase() === "VITARI";
}

/** S3 key root for instrument telemetry files. Vitari lands under a sibling prefix. */
export function telemetryLogsRoot(model?: string | null): string {
  return isVitariModel(model)
    ? "vitariinternallogs"
    : "avitiinternallogs";
}

/** Reads `model` or `instrumentModel` from a run or instrument payload. */
export function telemetryLogsRootFrom(source?: ModelCarrier | null): string {
  return telemetryLogsRoot(source?.model || source?.instrumentModel);
}

type FolderPart = string | String | null | undefined;

/**
 * Folder under the telemetry logs root for one instrument: `<instrumentID>_<serial>_<serial>`.
 * The serial number fills both trailing segments for every model, never the instrument display name,
 * so renaming an instrument does not change where its telemetry files are looked up (SW-29899).
 * Customer upload folders are separate and stay on the instrument name.
 */
export function telemetryInstrumentFolder(
  instrumentID: FolderPart,
  instrumentSerialNumber: FolderPart
): string {
  return `${instrumentID}_${instrumentSerialNumber}_${instrumentSerialNumber}`;
}
